/* 异步加载 一些弹窗组件 */
//const BimDemolitionBlockInfoBatchModify = () => import('../bimDemolitionBlockInfoBatchModify/BimDemolitionBlockInfoBatchModify.vue');

export default {
  components: {
    //BimDemolitionBlockInfoBatchModify
  },
  data() {
    return {
      isFold: false,
      form: {
        acqType: "",
        sectionInfo: "-----",
        completedNum: "-----",
        incompletedNum: "-----",
        completedArea: "-----",
        incompletedArea: "-----",
        completedAmout: "-----",
        incompletedAmout: "-----",
      },
      demolitionStatsData: "",
      options: "",
      open_land_acquision_box: "",
    };
  },
  mounted() {},
  methods: {
    demolitionStatsBox_close() {
      this.$emit("demolitionStats_close");
    },
    demolitionStatsBox_fold() {
      if (this.isFold) {
        this.isFold = false;
      } else {
        this.isFold = true;
      }
    },
    batchModify() {
      //this.open_land_acquision_box = 'BimDemolitionBlockInfoBatchModify';
      this.$emit("openBox", "BimDemolitionBlockInfoBatchModify");
    },
    editDemolitionStats(data) {
      console.log(data);
      this.demolitionStatsData = data;
      this.options = data.areaTreeDto != null ? data.areaTreeDto.totalInfo : [];
    },
    acqTypeChange(item) {
      console.log(item);
      let {
        completedAmout,
        completedArea,
        completedNum,
        section,
        incompletedAmout,
        incompletedArea,
        incompletedNum,
      } = item;
      this.form.sectionInfo = section;
      // 金额
      this.form.completedAmout = completedAmout;
      this.form.incompletedAmout = incompletedAmout;
      // 面积
      this.form.completedArea = completedArea;
      this.form.incompletedArea = incompletedArea;
      // 个数
      this.form.completedNum = completedNum;
      this.form.incompletedNum = incompletedNum;
    },
  },
  watch: {},
  destroyed() {},
};
